import { html } from 'lit';
import type { Purpose } from '@common/types/model.d.js';
import type { TefComs4p } from '@src/components/TefComs4p.js';

//
// renders a single purpose block
//
// {Purpose name}
// {Purpose description}
//   {subscription BLOCK}
export const singlePurposeView = function render(this: TefComs4p, purpose : Purpose) {
  return html`
    <p class="u-color--brand-1 u-sy--flat typography-display--6"><strong>${purpose.title}</strong></p>
    <div class="row align-items-center">
      <p class="col">
        ${purpose.shortDescription}
        ${this.getTemplateFn('tefPurposeDescriptionModal')(purpose)}
      </p>
      <div class="col-2">
        <tef-coms-button text="Ändern" @click=${() => this.editPurpose(purpose.purposeId)}></tef-coms-button>
      </div>
    </div>
  `;
};
